module.exports = require("./ki-KE.js");